import React, { useState, useEffect, useCallback } from 'react'
import {
  Form,
  Select,
  InputNumber,
  Button,
  Row,
  Col,
  message,
  Table,
  Input,
  DatePicker,
  Checkbox,
} from 'antd'
import { EditOutlined, CloseOutlined } from '@ant-design/icons'
import apiRequest from '../hooks/ApiRequest'
import moment from 'moment'
import { call } from 'file-loader'
const { Option } = Select

const QuoteGenerationForm = ({ form, customerData }) => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue } = form

  const [quotes, setQuotes] = useState([])
  const [products, setProducts] = useState([])
  const [insurers, setInsurers] = useState([])
  const [brokers, setBrokers] = useState([])
  const [coverages, setCoverages] = useState([])
  const [subCoverages, setSubCoverages] = useState([])
  const [loading, setLoading] = useState(false)
  const [editIndex, setEditIndex] = useState(null)
  const [productId, setProductId] = useState(null)
  const [riskItemDetails, setRiskItemDetails] = useState([])
  const [disableBasicFields, setDisableBasicFields] = useState(false)
  const [currentDate, setCurrentDate] = useState(new Date())
  const [ageFcp, setAgeFcp] = useState('')
  const [monthlyTermPayment, setMonthlyTermPayment] = useState(false)
  const [selectedInsurer, setSelectedInsurer] = useState(null)
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment().add(12, 'months'));
  const [specficProdcutId, setSpecficProdcutId] = useState(null);
  const [minimumPremium, setMinimumPremium] = useState(0);
  const [currencyList, setCurrencyList] = useState([])
  const [currencyDisabled, setCurrencyDisabled] = useState(false)
  const [currencyRates, setCurrencyRates] = useState({})
  const selectProductId = localStorage.getItem('productId');
  const selectProductName = localStorage.getItem('productName');
  useEffect(() => {
    const loadProducts = async () => {
      try {
        const res = await apiRequest(
          process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts',
          'GET',
        )
        if (!res?.success) {
          throw new Error('Failed to fetch products')
        }
        if (!res?.data?.data || res.data.data.length === 0) {
          message.warning('No products available')
          return
        }
        // Assuming res.data.data is an array of products
        setProducts(res?.data?.data || [])
      } catch (err) {
        console.error(err)
        message.error('Failed to load products')
      }

    }
    loadProducts()
  }, [])

  const handleProductChange = async value => {
    try {
      setFieldsValue({
        insurer: undefined,
        broker: undefined,
        coverage: undefined,
        subCoverage: undefined,
      })
      setInsurers([])
      setBrokers([])
      setCoverages([])
      setSubCoverages([])
      setProductId(value)

      const res = await apiRequest(
        process.env.REACT_APP_BASE_URL_INSURER +
        `/api/Insurer/GetInsurersByProductId/${value}`,
        'GET',
      )
      if (!res?.success) {
        throw new Error('Failed to fetch insurers')
      }
      setInsurers(res?.data || [])
    } catch (err) {
      console.error(err)
      message.error('Failed to load insurers')
    }
  }

  const handleInsurerChange = async value => {
    debugger
    const selectedInsurer = insurers.find(c => c.userId === value)
    setSelectedInsurer(selectedInsurer)
    setFieldsValue({ reinsurancelimit: selectedInsurer?.maxLimit })

    try {
      setFieldsValue({
        broker: undefined,
        coverage: undefined,
        subCoverage: undefined,
      })
      setBrokers([])
      setCoverages([])
      setSubCoverages([])
      setCurrencyList([])

      // 1️⃣ Fetch Brokers
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/GetBrokersByInsurerId/${value}`,
        'GET'
      )
      if (!res?.success) throw new Error('Failed to fetch brokers')
      setBrokers(res?.data || [])

      // 2️⃣ Fetch Insurer Product
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurerProductByInsurerIdProductId?productId=${productId}&insurerId=${value}`,
        'GET'
      )
      if (!response?.success) throw new Error('Failed to fetch insurer product')
      const { data } = response
      setSpecficProdcutId(data?.insurerProduct?.id || null)
      setMinimumPremium(data?.insurerProduct?.minimumPremium || 0)


      const res_2 = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetCurrenciesByInsurer/GetCurrency/${value}`,
        'GET'
      )
      if (!res_2 || res_2.success === false) {
        throw new Error('Failed to fetch currencies by insurer')
      }
      const currencies = res_2.data.data || [];
      setCurrencyList(currencies);

      if (currencies.length === 0) {
        setFieldsValue({ currency: undefined });
        setCurrencyDisabled(true);
      } else {
        setCurrencyDisabled(false);
      }

      // 3️⃣ Fetch Coverages
      const res_1 = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetRiskCoversByInsurerProductId/${data.insurerProduct.id}`,
        'GET'
      )
      if (!res_1?.success) throw new Error('Failed to fetch coverages')
      setCoverages(res_1?.data || [])
    } catch (err) {
      console.error(err)
      message.error('Failed to load insurer data')
    }
  }



  const handleCurrencyChange = async value => {
    try {
      setFieldsValue({ currency: value })

      const selectedCurrency = currencyList.find(c => c.currencyCode === value)
      if (!selectedCurrency) {
        message.error('Selected currency not found')
        return
      }

      if (riskItemDetails.length === 0) {
        message.warning('No risk items to convert currency for')
        return
      }

      const updatedRiskItems = riskItemDetails.map(item => {
        const fromRate = currencyRates[item.currency] || 1
        const toRate = currencyRates[value] || 1
        const convertedPremium = (item.annualpremium / fromRate) * toRate
        const convertedProrata = (item.prorata / fromRate) * toRate
        const convertedTermPremium = (item.termpremium / fromRate) * toRate
        const convertedSumInsured = (item.sumInsured / fromRate) * toRate

        return {
          ...item,
          annualpremium: convertedPremium.toFixed(2),
          prorata: convertedProrata.toFixed(2),
          termpremium: convertedTermPremium.toFixed(2),
          sumInsured: convertedSumInsured.toFixed(2),
          currency: value,
          currencyName: selectedCurrency.currencyName,
        }
      })


      setRiskItemDetails(updatedRiskItems)

      message.success(`Currency changed to ${selectedCurrency.currencyName}`)
    } catch (error) {
      console.error('Currency Change Error:', error)
      message.error('Failed to change currency')
    }
  }


  const handleCoverageChange = async value => {
    try {
      setFieldsValue({ subCoverage: undefined })
      setSubCoverages([])

      const res = await apiRequest(
        process.env.REACT_APP_BASE_URL_INSURER +
        `/api/Insurer/GetRiskItemsByCoverId/${value}/${selectedInsurer.userId}`,
        'GET',
      )
      if (!res?.success) {
        throw new Error('Failed to fetch sub-coverages')
      }


      setSubCoverages(res?.data || [])
    } catch (err) {
      console.error(err)
      message.error('Failed to load sub-coverages')
    }
  }

  const formatDate = dateObj => {
    const date = new Date(dateObj).toGMTString()
    return `${date}`
  }


  const handleSubmit = async e => {
    e.preventDefault()
    try {
      // debugger
      // const values = await validateFields()
      const values = await validateFields(['insurer', 'broker', 'paymentTerm', 'currency'])
      setLoading(true)
      setCurrentDate(new Date())

      if (riskItemDetails.length === 0) {
        message.error('Please add at least one risk item before submitting.')
        return
      }

      const totalPremiumwithStampDuty = riskItemDetails.reduce(
        (sum, item) => sum + parseFloat(item.annualpremium),
        0,
      ) * 1.05

      const proratatotaltermpremium = riskItemDetails.reduce(
        (sum, item) => sum + parseFloat(item.prorata),
        0,
      )

      const totalPremiumwithoutStampDuty = riskItemDetails.reduce(
        (sum, item) => sum + parseFloat(item.annualpremium),
        0
      ).toFixed(2)

      let totaltermpremium = 0

      // if (monthlyTermPayment) {
      //   totaltermpremium = (totalPremiumwithoutStampDuty / 12).toFixed(2)
      // } else {
        if (values.paymentTerm === 3) {
          totaltermpremium = (totalPremiumwithoutStampDuty / 4).toFixed(2)
        } else if (values.paymentTerm === 4) {
          totaltermpremium = (totalPremiumwithoutStampDuty / 3).toFixed(2)
        } else if (values.paymentTerm === 6) {
          totaltermpremium = (totalPremiumwithoutStampDuty / 2).toFixed(2)
        } else {
          totaltermpremium = totalPremiumwithoutStampDuty
        }
      //}


      let grandtotaltermpremium = 0

      // if (monthlyTermPayment) {
      //   grandtotaltermpremium = (totalPremiumwithStampDuty / 12).toFixed(2)
      // } else {
        if (values.paymentTerm === 3) {
          grandtotaltermpremium = (totalPremiumwithStampDuty / 4).toFixed(2)
        } else if (values.paymentTerm === 4) {
          grandtotaltermpremium = (totalPremiumwithStampDuty / 3).toFixed(2)
        } else if (values.paymentTerm === 6) {
          grandtotaltermpremium = (totalPremiumwithStampDuty / 2).toFixed(2)
        } else {
          grandtotaltermpremium = totalPremiumwithStampDuty
        }
      //}

      const emailRequest = {
        customerDetail: {
          customerId: customerData?.id,
          notifyCustomer: customerData?.emailAddress,
        },
        insurerDetail: {
          insurerId: values.insurer,
          notifyInsurer: insurers.find(c => c.userId === values.insurer)?.email,
        },
        brokerDetail: {
          brokerId: values?.broker,
          notifyBroker: brokers.find(c => c.id === values.broker)?.email,
          brokerRole: brokers.find(c => c.id === values.broker)?.roleId,
        },
      }
debugger
      const payload = {
        clientdetail: {
          id: customerData?.id || 0,
          modifiedby: 1,
          entitytype: 'Individual',
          nationalid: customerData?.nationalID || '',
          clientfirstname: customerData?.customerName || '',
          clientsurname: customerData?.customerSurname || '',
          clientcorporatename: customerData?.corporateName || '',
          clientemailaddress: customerData?.emailAddress || '',
          clientage: parseInt(customerData?.age) || 0,
          clientgender: customerData?.gender || '',
          clientaddress1: customerData?.address || '',
          clientaddress2: '',
          suburb: customerData?.suburb || '',
          city: customerData?.city || '',
          clientcontactnumber: customerData?.mobile || '',
          createdby: 1,
        },
        pquotationdetail: {
          totalannualpremium: totalPremiumwithoutStampDuty,
          totaltermpremium: totaltermpremium,
          stampdutyannualpremium: (totalPremiumwithStampDuty * 0.05).toFixed(2),
          stampdutytermpremium: (proratatotaltermpremium * 0.05).toFixed(2),
          grandtotalannualpremium: totalPremiumwithStampDuty,
          grandtotaltermpremium: grandtotaltermpremium,
          proratatotaltermpremium: proratatotaltermpremium.toFixed(2),
          clientid: 0,
          createdby: '1',
          customername:
            customerData?.customerName + ' ' + customerData?.customerSurname,
          modifiedby: 1,
          nationalid: customerData?.nationalID || '',
          isactive: true,
          isdeleted: false,
          policyriskcover: '',
          riskitemList: riskItemDetails.map(item => ({
            riskitemid: item.subCoverageId?.toString() || '',
            policy_cover: item.coverage,
            policy_cover_id: item.coverageId,
            riskitemname: item.subCoverage,
            monthlyPayment: 0,
            covertype: '',
            address: item.address || '',
            suminsured: item.sumInsured,
            rate: item.rate,
            prorata: item.prorata,
            annualpremium: item.annualpremium,
            termpremium: item.termpremium,
            itempstartdate: item.itempstartdate,
            itempexpirydate: item.itempexpirydate,
            id: 0,
            membername: item.membername || '',
            gender: item.gender || '',
            age: item.age || '',
            premiumfactor: 0,
            monthlypremium: 0,
            relationship: item.relationship || '',
            grand_total: item.annualpremium,
            policynumber: '',
            policyquotatonid: 0,
          })),
          policystartdate: new Date(startDate).toGMTString(),
          policyexpirytdate: new Date(endDate).toGMTString(),
          currency: String(values.currency || 'USD'),
          paymentterms: JSON.stringify(values.paymentTerm),
          customerid: customerData?.id,
          customeremail: customerData?.emailAddress,
          productname:
            products.find(prod => prod.productid === selectProductId)
              ?.productname || '',
          productid: specficProdcutId,
          riskcoverid: values.coverage,
          id: 0,
          reinsurancelimit:
            insurers.find(c => c.userId === values.insurer)?.maxLimit || 0,
          ownretention: 0,
          risklocation1: '',
          risklocation2: '',
          risksuburb: '',
          riskcity: '',
          buildingusage: '',
          risksecurityfeatures: '',
          riskbuildingmaterial: '',
          riskowner: '',
          quotationstatus: '',
          createdbyname: '',
          modifiedbyname: '',
          quotationnumber: '',
          InsurerId: values.insurer,
          TotalSumInsured: riskItemDetails.reduce(
            (sum, item) => sum + parseFloat(item.sumInsured),
            0,
          ),
          productGenId: localStorage.getItem('productId') || selectProductId,
          emailRequest: JSON.stringify(emailRequest),
          VehicleRegistration: values.VehicleRegistration || '',
          Make: values.Make || '',
          Model: values.Model || '',
          Year: values.Year || 0,
          brokerId: values.broker,
          BrokerEmail: brokers.find(c => c.id === values.broker)?.email || '',
          brokername: brokers.find(c => c.id === values.broker)?.name || '',
          isMonthlyDeduction:false,
          monthlyTermPayment: 0.00,
        },
      }

      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/quotation/AddQuotationByClient`,
        'POST',
        payload,
      )
      if (!response?.success) {
        throw new Error('Failed to generate quote')
      }

      message.success('Quote generated successfully!')
      resetFields()
      setDisableBasicFields(false)
      setRiskItemDetails([])
      setEditIndex(null)
    } catch (err) {
      console.error(err)
      message.error('Validation failed or network error.')
    } finally {
      setLoading(false)
    }
  }

  const handleEdit = index => {
    const quote = riskItemDetails[index]
    setFieldsValue({
      type: quote.type,
      // insurer: quote.insurer,
      // broker: quote.broker,
      coverage: quote.coverageId,
      subCoverage: quote.subCoverageId,
      sumInsured: quote.sumInsured,
      address: quote.address,
      rate: quote.rate,
      policyStartDate: moment(new Date(quote.itempstartdate)),
      policyEndDate: moment(new Date(quote.itempexpirydate)),
      name: quote.membername || '',
      genderFcp: quote.gender || '',
      ageFcp: quote.age || '',
      relation: quote.relationship || '',
    })
    setEditIndex(index)
    setAgeFcp(quote.age || '')
  }

  const handleDelete = index => {
    const updatedQuotes = [...riskItemDetails]
    updatedQuotes.splice(index, 1)
    setRiskItemDetails(updatedQuotes)


    if (updatedQuotes.length === 0) {
      setDisableBasicFields(false);
      setCurrencyDisabled(false);

      if (productId) {
        handleProductChange(productId);
      }
      setFieldsValue({
        insurer: undefined,
        broker: undefined,
        coverage: undefined,
        subCoverage: undefined,
        currency: undefined,
        paymentTerm: undefined,
        sumInsured: undefined,
        address: undefined,
        rate: undefined,
        name: undefined,
        genderFcp: undefined,
        relation: undefined,
        policyStartDate: moment(),
        policyEndDate: moment().add(12, "months"),
      });
    }

    message.success('Risk Item deleted successfully!')
  }

  const findDayDifference = (date1, date2) => {
    // always round down
    return Math.floor(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24))
  }

  const handleDobChange = date => {
    if (!date) {
      setAgeFcp('')
      return
    }

    const now = moment()
    const years = now.diff(date, 'years')
    const months = now.diff(date, 'months')
    const days = now.diff(date, 'days')

    let displayAge = ''

    if (years >= 1) {
      displayAge = `${years} year${years > 1 ? 's' : ''}`
    } else if (months >= 1) {
      displayAge = `${months} month${months > 1 ? 's' : ''}`
    } else {
      displayAge = `${days} day${days > 1 ? 's' : ''}`
    }

    setAgeFcp(displayAge)
  }

  const columns = [
    { title: 'Coverage', dataIndex: 'coverage', key: 'coverage' },
    { title: 'Sub-Coverage', dataIndex: 'subCoverage', key: 'subCoverage' },
    { title: 'Sum Insured', dataIndex: 'sumInsured', key: 'sumInsured' },
    { title: 'Term Premium', dataIndex: 'termpremium', key: 'termpremium' },
    { title: 'Annual Premium', dataIndex: 'annualpremium', key: 'annualpremium' },
    { title: 'Generated At', dataIndex: 'timestamp', key: 'timestamp' },
    {
      title: 'Action',
      render: (_, record, index) => (
        <>
          <Button
            type="primary"
            onClick={() => handleEdit(index)}
            style={{ marginRight: 8 }}>
            <EditOutlined />
          </Button>
          <Button type="danger" onClick={() => handleDelete(index)}>
            <CloseOutlined />
          </Button>
        </>
      ),
    },
  ]
  // get selected product insurers
  useEffect(() => {
    handleProductChange(selectProductId)
  }, [selectProductId])
  return (
    <>
      <Form layout="vertical" onSubmit={handleSubmit}>
        <Row gutter={16}>
          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Insurer">
              {getFieldDecorator('insurer', {
                rules: [{ required: true, message: 'Please select insurer' }],
              })(
                <Select
                  placeholder="Select insurer"
                  onChange={handleInsurerChange}
                  disabled={disableBasicFields}>
                  {insurers.map(ins => (
                    <Option key={ins.userId} value={ins.userId}>
                      {ins.firstName} {ins.lastName}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Col>

          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Broker">
              {getFieldDecorator('broker', {
                rules: [{ required: true, message: 'Please select broker' }],
              })(
                <Select
                  placeholder="Select broker"
                  disabled={disableBasicFields}>
                  {brokers.map(broker => (
                    <Option key={broker.id} value={broker.id}>
                      {broker.name}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Col>

          {/* Second Row */}
          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Payment Term (Months)">
              {getFieldDecorator('paymentTerm', {
                rules: [
                  { required: true, message: 'Please select payment term' },
                ],
              })(
                <Select
                  placeholder="Select payment term"
                  disabled={disableBasicFields}>
                  {[3, 4, 6, 12].map(term => (
                    <Option key={term} value={term}>
                      {term}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Col>
          {Number(form.getFieldValue('paymentTerm')) === 12 && (
            <Col xs={20} md={12} lg={8}>
              <Form.Item label="Monthly Term Payment">
                <Checkbox
                  checked={monthlyTermPayment}
                  onChange={e => setMonthlyTermPayment(e.target.checked)}>
                  {/* Monthly Term Payment */}
                </Checkbox>
              </Form.Item>
            </Col>
          )}

          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Currency">
              {getFieldDecorator('currency', {
                rules: [{ required: true, message: 'Please select currency' }],
              })(
                <Select
                  placeholder="Select currency"
                  disabled={disableBasicFields || currencyDisabled || currencyList.length === 0}
                  notFoundContent={currencyList.length === 0 ? 'No currencies available' : null}
                >
                  {currencyList.map(cur => (
                    <Option key={cur.id} value={cur.id}>
                      {cur.currencyName} ({cur.currencyCode})
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>

          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Coverage Option">
              {getFieldDecorator('coverage')(
                <Select
                  placeholder="Select coverage option"
                  onChange={handleCoverageChange}>
                  {coverages.map(cov => (
                    <Option key={cov.riskCoverId} value={cov.riskCoverId}>
                      {cov.riskCoverName}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Col>

          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Sub-Coverage Option">
              {getFieldDecorator('subCoverage')(
                <Select placeholder="Select sub-coverage option"
                  onChange={(value) => {
                    const selected = subCoverages.find(sub => sub.riskItemId === value);
                    const minRate = selected?.ratePercentage || 0;
                    setFieldsValue({
                      min_rate: minRate,
                      rate: minRate
                    });
                  }}
                >
                  {subCoverages.map(sub => (
                    <Option key={sub.riskItemId} value={sub.riskItemId}>
                      {sub.riskItemName}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Col>

          {/* Third Row */}
          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Sum Insured">
              {getFieldDecorator('sumInsured', {
                rules: [
                  {
                    validator: async (_, value, callback) => {
                      if (value === undefined || value === null || value === '') {
                        callback('Please Enter Sum Insured');
                        return;
                      }

                      const numericValue = Number(value);
                      if (isNaN(numericValue)) {
                        callback('Amount must be a number!');
                        return;
                      }

                      if (!minimumPremium) {
                        callback('Minimum premium not set for this product');
                        return;
                      }

                      // Get selected currency
                      const selectedCurrency = await validateFields(['currency']);
                      const fromRate = currencyRates[selectedCurrency]?.conversionRate || 1;
                      const toRate = currencyRates['USD']?.conversionRate || 1;

                      if (!fromRate || !toRate) {
                        callback('Currency conversion rate not available');
                        return;
                      }

                      // Convert entered value -> USD
                      const amountInUSD = (numericValue / fromRate) * toRate;

                      if (amountInUSD < minimumPremium) {
                        callback(`Amount must be greater than or equal to ${minimumPremium} USD`);
                      } else {
                        callback();
                      }
                    },
                  },
                ],
              })(
                <InputNumber
                  style={{ width: '100%' }}
                  placeholder="Enter sum insured"
                  min={1}
                  step={0.01}
                  stringMode
                  parser={(value) => value.replace(/[^\d.]/g, '')} // allow only numbers and decimals
                  onKeyDown={(e) => {
                    if (e.key === ' ' || e.key === '-' || e.key === '+') {
                      e.preventDefault(); // block spaces and +/-
                    }
                  }}
                />
              )}
            </Form.Item>
          </Col>



          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Address/Item Details">
              {getFieldDecorator('address', {
                rules: [{ required: true, message: 'Please enter Address' }],
              })(<Input placeholder="Address/Item Details" />)}
            </Form.Item>
          </Col>

          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Minimum rate">
              {getFieldDecorator('min_rate', {
                // rules: [{ required: true, message: 'Please select Insurer' }],
              })(<Input disabled />)}
            </Form.Item>
          </Col>

          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Rate">
              {getFieldDecorator('rate', {
                initialValue: form.getFieldValue('min_rate') || 0,
                rules: [
                  { required: true, message: 'Please input Rate' },
                  {
                    validator: (_, value, callback) => {
                      const minRate = parseFloat(form.getFieldValue('min_rate')) || 0;
                      const rate = parseFloat(value);

                      if (value === undefined || value === null || value === '') {
                        callback('Please input Rate');
                      } else if (isNaN(rate)) {
                        callback('Rate must be a number');
                      } else if (rate < minRate) {
                        callback(`Rate must be greater than or equal to ${minRate}`);
                      } else {
                        callback();
                      }
                    },
                  },
                ],
              })(
                <Input
                  placeholder="Enter rate"
                  onChange={(e) => {
                    // Only allow numbers and decimals
                    const value = e.target.value.replace(/[^\d.]/g, '');
                    e.target.value = value;
                    form.validateFields(['rate'], { force: true });
                  }}
                />
              )}
            </Form.Item>
          </Col>



          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Reinsurance limit">
              {getFieldDecorator('reinsurancelimit', {
                // rules: [{ required: true, message: 'Please select Insurer' }],
              })(<Input disabled />)}
            </Form.Item>
          </Col>

          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Policy Start Date">
              {getFieldDecorator('policyStartDate', {
                initialValue: moment(),
                rules: [{ required: true, message: 'Please select start date' }],
              })(
                <DatePicker
                  style={{ width: '100%' }}
                  disabledDate={(current) => current && current < moment().startOf('day')}
                  onChange={(date) => {
                    setStartDate(date);
                    // Automatically update end date to be 12 months after new start date
                    const newEndDate = moment(date).add(12, 'months');
                    setEndDate(newEndDate);
                    form.setFieldsValue({
                      policyEndDate: newEndDate
                    });
                  }}
                />
              )}
            </Form.Item>
          </Col>

          <Col xs={24} md={12} lg={8}>
            <Form.Item label="Policy End Date">
              {getFieldDecorator('policyEndDate', {
                initialValue: moment().add(12, 'months'),
                rules: [{ required: true, message: 'Please select end date' }],
              })(
                <DatePicker
                  style={{ width: '100%' }}
                  disabledDate={(current) => current && current < startDate}
                  onChange={(date) => setEndDate(date)}
                />
              )}
            </Form.Item>
          </Col>

          {/* Conditional Fields - Life Insurance */}
          {(productId === 3 || productId === 5) && (
            <>
              <Col xs={24} md={12} lg={6}>
                <Form.Item label="Date of Birth">
                  {getFieldDecorator('dob')(
                    <DatePicker
                      disabledDate={current =>
                        current.isAfter(moment().subtract(1, 'day')) ||
                        current.isBefore(moment().subtract(65, 'years'))
                      }
                      onChange={handleDobChange}
                    />,
                  )}
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Age">
                  <Input disabled placeholder="Age" value={ageFcp} />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={6}>
                <Form.Item label="Relationship">
                  {getFieldDecorator('relation')(
                    <Select placeholder="Select relationship">
                      <Option value="">---Select--</Option>
                      <Option value="Principal Member">Principal Member</Option>
                      <Option value="Spouse">Spouse</Option>
                      <Option value="Child">Child</Option>
                      <Option value="Grand Parent">Grand Parent</Option>
                      <Option value="Other">Other</Option>
                    </Select>,
                  )}
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Name">
                  {getFieldDecorator('name')(<Input placeholder="Name" />)}
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Gender">
                  {getFieldDecorator('genderFcp')(
                    <Select placeholder="Select gender">
                      <Option value="">---Select--</Option>
                      <Option value="Male">Male</Option>
                      <Option value="Female">Female</Option>
                    </Select>,
                  )}
                </Form.Item>
              </Col>
            </>
          )}

          {/* Conditional Fields - Motor Insurance */}
          {productId === 10 && selectProductName === "Motor Insurance" && (
            <>
              {['VehicleRegistration', 'Make', 'Model', 'Year'].map(
                (field, index) => (
                  <Col xs={24} md={12} lg={6} key={field}>
                    <Form.Item label={field.replace(/([A-Z])/g, ' $1').trim()}>
                      {getFieldDecorator(field)(<Input placeholder={field} />)}
                    </Form.Item>
                  </Col>
                ),
              )}
            </>
          )}

          <Col lg={24} style={{ textAlign: 'right', marginTop: 8 }}>
            <Button
              type="dashed"
              onClick={async () => {
                try {
                  const values = await validateFields([
                    'coverage',
                    'subCoverage',
                    'sumInsured',
                    'paymentTerm',
                    'genderFcp',
                    'relation',
                    'name',
                    'address',
                    'policyStartDate',
                    'policyEndDate',
                    'rate',
                  ])

                  const selectedSubCoverage = subCoverages.find(
                    s => s.riskItemId === values.subCoverage,
                  )

                  const ratePercentage = values.rate

                  const basePremium = (values.sumInsured * ratePercentage) / 100
                  let term_premium = '0'

                  if (monthlyTermPayment) {
                    term_premium =
                      ((values.sumInsured / 100) * ratePercentage) /
                      parseInt(12)
                  } else {
                    if (values.paymentTerm == 3) {
                      term_premium = ((values.sumInsured / 100) * ratePercentage) / 4
                    } else if (values.paymentTerm == 4) {
                      term_premium = ((values.sumInsured / 100) * ratePercentage) / 3
                    } else if (values.paymentTerm == 6) {
                      term_premium = ((values.sumInsured / 100) * ratePercentage) / 2
                    } else if (values.paymentTerm == 12) {
                      term_premium = (values.sumInsured / 100) * ratePercentage
                    }
                  }

                  var Noofdays =
                    findDayDifference(
                      new Date(values.policyStartDate),
                      new Date(values.policyEndDate),
                    )
                  let prorata =
                    ((values.sumInsured / 100) * ratePercentage * Noofdays) /
                    365

                  const newItem = {
                    coverage:
                      coverages.find(c => c.riskCoverId === values.coverage)
                        ?.riskCoverName || values.coverage,
                    coverageId: values.coverage,
                    subCoverage:
                      selectedSubCoverage?.riskItemName || values.subCoverage,
                    subCoverageId: values.subCoverage,
                    sumInsured: values.sumInsured,
                    prorata: prorata.toFixed(2),
                    rate: ratePercentage,
                    timestamp: new Date().toLocaleString(),
                    membername: values.name || '',
                    gender: values.genderFcp || '',
                    age: ageFcp || '',
                    relationship: values.relation || '',
                    address: values.address || '',
                    annualpremium: basePremium.toFixed(2),
                    termpremium: term_premium.toFixed(2),
                    itempstartdate: new Date(values.policyStartDate).toGMTString(),
                    itempexpirydate: new Date(values.policyEndDate).toGMTString(),
                  }

                  if (editIndex !== null) {
                    // Update existing item
                    const updatedItems = [...riskItemDetails]
                    updatedItems[editIndex] = newItem
                    setRiskItemDetails(updatedItems)
                    setEditIndex(null)
                    message.success('Risk Item updated successfully!')
                  } else {
                    // Add new item
                    setRiskItemDetails(prev => [...prev, newItem])
                    message.success('Risk Item added!')
                  }

                  // Disable type, insurer, broker
                  setDisableBasicFields(true)

                  // Clear fields except for insurer and broker
                  setFieldsValue({
                    coverage: undefined,
                    subCoverage: undefined,
                    sumInsured: undefined,
                    address: undefined,
                    rate: undefined,
                    name: undefined,
                    genderFcp: undefined,
                    relation: undefined,
                    policyStartDate: moment(),
                    policyEndDate: moment().add(12, 'months'),
                  })
                  setAgeFcp('')

                  console.log('Risk Item Details:', newItem)
                } catch (err) {
                  console.error(err)
                  message.error(
                    'Please select Coverage, Sub-Coverage, and enter Sum Insured',
                  )
                }
              }}>
              {editIndex !== null ? 'Update Risk Item' : 'Add Risk Item'}
            </Button>
          </Col>

          <Col xs={24} style={{ marginTop: 20 }}>
            <Table
              columns={columns}
              dataSource={riskItemDetails}
              pagination={false}
              rowKey={(record, index) => index}
            />
          </Col>

          <Col xs={24} style={{ marginTop: 10, textAlign: 'right' }}>
            <Button htmlType="submit" type="primary" loading={loading}>
              {editIndex !== null ? 'Update Quote' : 'Generate Quote'}
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default Form.create()(QuoteGenerationForm)
